var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventoryCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171283)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171283)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171283)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171283)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.973 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.973 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.665 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.06 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.35 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.1 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9596 85.5C25.9846 85.5 24.1346 84.9 22.6096 83.45C21.3846 82.3 20.9346 80.3 20.9346 78.275V70.1H24.4346V77.85C24.4346 79.325 24.7096 80.4 25.4846 81.05C26.3346 81.775 27.7346 82 29.2096 82H31.2096V70.1H34.7096V85.5H28.9596ZM27.9346 67.875C26.8346 67.875 25.8846 67.225 25.8846 66C25.8846 64.9 26.7846 64.15 27.9346 64.15C29.1096 64.15 29.9846 64.9 29.9846 66C29.9846 67.225 29.0346 67.875 27.9346 67.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1344 68.3L50.1094 81.425C50.1094 85.225 48.6094 87.875 43.6844 87.875C42.3344 87.875 41.5594 87.7 40.0344 87.275L39.7844 83.75C41.1344 84.175 42.2594 84.375 43.4344 84.375C45.3594 84.375 46.3594 84.125 46.5844 82.375H46.1844C41.4094 82.375 37.6094 80.35 37.6094 75.325C37.6094 70.95 41.1844 68.3 46.1844 68.3H50.1344ZM41.1094 75.325C41.1094 77.65 42.9094 78.875 45.1594 78.875H46.6344V71.8H45.1594C43.0844 71.8 41.1094 73.2 41.1094 75.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4146 87.875C53.7646 87.875 53.0646 87.775 52.6396 87.65L52.3896 84.15C53.0396 84.325 53.5146 84.375 54.0396 84.375C55.4397 84.375 55.9146 83.65 55.9146 81.925V68.3H59.4146V78.875H62.1147V82.375H59.3896C59.1896 86.225 57.7147 87.875 54.4146 87.875ZM57.5896 66.175C56.4896 66.175 55.5396 65.525 55.5396 64.3C55.5396 63.2 56.4396 62.45 57.5896 62.45C58.7646 62.45 59.6396 63.2 59.6396 64.3C59.6396 65.525 58.6896 66.175 57.5896 66.175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.625 82.375V78.875H71C71.25 77.775 71.425 76.35 71.425 75.3C71.425 74.275 71.075 73.05 70.2 72.275C69.5 71.65 68.5 71.325 67.25 71.325C65.925 71.325 64.925 71.6 63.625 72.425L62.175 69.375C63.8 68.45 65.575 67.825 67.675 67.825C69.725 67.825 71.45 68.525 72.65 69.75C73.975 71.075 74.9 73.05 74.9 75.575C74.9 76.7 74.775 77.825 74.575 78.875H77.275V82.375H60.625ZM67.225 65.725C66.125 65.725 65.175 65.075 65.175 63.85C65.175 62.75 66.075 62 67.225 62C68.4 62 69.275 62.75 69.275 63.85C69.275 65.075 68.325 65.725 67.225 65.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8105 82.375V78.875H79.2355C79.1105 78.375 79.0605 77.825 79.0605 77.275C79.0605 73.025 82.4105 69.625 86.5355 69.625C90.7605 69.625 94.1355 72.95 94.1355 77.275C94.1355 77.825 94.0605 78.375 93.9605 78.875H96.7606V82.375H92.0855C90.6855 83.85 88.6855 84.75 86.5355 84.75C84.4105 84.75 82.4605 83.825 81.0855 82.375H76.8105ZM86.5355 81.25C88.8355 81.25 90.6355 79.575 90.6355 77.225C90.6355 74.875 88.9355 73.125 86.5355 73.125C84.2105 73.125 82.5605 74.95 82.5605 77.225C82.5605 79.475 84.2855 81.25 86.5355 81.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2686 82.375V78.875H98.7186V62.1H102.219V82.375H96.2686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.355 82.375V62.1H110.855V82.375H107.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6596 117.375H22.0596V97.1H25.6596V117.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1783 117.375V103.525C32.3533 103.125 34.9783 102.8 36.5033 102.8C40.1033 102.8 43.0033 103.95 43.0033 108.575V117.375H39.5033V109.575C39.5033 107 38.4283 106.225 36.3533 106.225C35.6033 106.225 34.6783 106.325 33.6783 106.5V117.375H30.1783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5328 117.375H49.7328L44.8828 103.3H48.5578L52.1328 114.05L55.7078 103.3H59.3828L54.5328 117.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.273 114.25H68.648C70.123 114.25 72.023 113.7 72.773 113L74.323 116.125C72.823 116.95 70.948 117.675 68.173 117.675C63.723 117.675 60.448 114.475 60.448 110.25C60.448 105.9 63.773 102.8 67.923 102.8C72.248 102.8 75.373 105.975 75.198 111.4H64.048C64.498 113.325 66.098 114.25 68.273 114.25ZM67.873 105.9C65.998 105.9 64.598 107 64.173 108.5H71.523C71.148 106.775 69.773 105.9 67.873 105.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9322 117.375V103.525C80.1072 103.125 82.7322 102.8 84.2572 102.8C87.8572 102.8 90.7572 103.95 90.7572 108.575V117.375H87.2572V109.575C87.2572 107 86.1822 106.225 84.1072 106.225C83.3572 106.225 82.4322 106.325 81.4322 106.5V117.375H77.9322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0088 106.55V103.3H95.6588V98.15H99.1588V103.3H104.509V106.55H99.1588V111.65C99.1588 113.55 99.8088 114.125 101.659 114.125H104.609V117.375H101.284C97.3838 117.375 95.6588 116.275 95.6588 112.9V106.55H93.0088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.703 117.675C109.378 117.675 106.078 114.45 106.078 110.25C106.078 106.075 109.378 102.8 113.703 102.8C118.028 102.8 121.328 106.075 121.328 110.25C121.328 114.45 118.028 117.675 113.703 117.675ZM113.703 114.25C116.153 114.25 117.653 112.475 117.653 110.25C117.653 108.05 116.153 106.225 113.703 106.225C111.253 106.225 109.753 108.05 109.753 110.25C109.753 112.475 111.253 114.25 113.703 114.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.347 103.075V106.425H130.347C129.797 106.425 128.097 106.525 127.672 106.675V117.375H124.172V103.675C125.922 103.325 128.247 103.075 129.697 103.075H132.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.784 122.375L135.034 118.725C136.409 119.325 138.609 119.775 139.984 119.775C142.134 119.775 143.659 119.075 143.659 117.425V117.125C142.709 117.325 141.759 117.425 140.859 117.425C137.284 117.425 134.734 116.275 134.734 111.65V103.275H138.259V110.65C138.259 113.225 139.084 114 141.034 114C141.784 114 142.634 113.925 143.659 113.625V103.275H147.159V116.3C147.159 121.275 145.409 123 139.834 123C138.734 123 136.909 122.725 135.784 122.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171283",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171283",
    result: "effect2_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171283",
    result: "effect3_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171283",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171283",
    result: "effect2_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171283",
    result: "effect3_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171283",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171283",
    result: "effect2_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171283",
    result: "effect3_dropShadow_5438_171283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171283",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#939CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#6370FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryCard);
export default __webpack_public_path__ + "static/media/inventoryCard.5b8291da025f899d921d8c17bfef0ac1.svg";
export { ForwardRef as ReactComponent };